import { Button, type ButtonProps } from '../primitives/button.js'
import EntityAvatar, { type EntityAvatarProps } from './entity-avatar.js'
import type { FC, HTMLAttributes } from 'react'
import styles from './list-item.styles.module.css'

export interface ListItemSize {
  size?: 'tiny' | 'small' | 'normal'
}

export interface StyledListItemProps extends HTMLAttributes<HTMLDivElement> {
  ref?: React.Ref<HTMLDivElement>
}

export const StyledListItem: FC<StyledListItemProps> = ({ ref, className, ...props }) => {
  const classes = [styles.listItem, className].filter(Boolean).join(' ')
  return <div ref={ref} {...props} className={classes} style={props.style} />
}

export const StyledButton = ({ className, ...props }: ButtonProps) => {
  const classes = [styles.button, className].filter(Boolean).join(' ')
  return <Button {...props} className={classes} style={props.style} />
}

export const StyledEntityAvatar = ({ className, ...props }: EntityAvatarProps) => {
  const classes = [styles.entityAvatar, className].filter(Boolean).join(' ')
  return <EntityAvatar {...props} className={classes} />
}

export interface StyledListItemAvatarProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'small' | 'large' | 'tiny' | 'medium' | undefined
}

export const StyledListItemAvatar: FC<StyledListItemAvatarProps> = ({ size, className, ...props }) => {
  const classes = [
    styles.listItemAvatar,
    size === 'tiny' ? styles.listItemAvatarTiny : styles.listItemAvatarDefault,
    className,
  ]
    .filter(Boolean)
    .join(' ')
  return <div {...props} className={classes} style={props.style} />
}

export interface StyledListItemTextProps extends ListItemSize, HTMLAttributes<HTMLDivElement> {
  primary?: React.ReactNode
  secondary?: React.ReactNode
}

export const StyledListItemText: FC<StyledListItemTextProps> = ({ primary, secondary, size, className, ...props }) => {
  const rootClasses = [styles.listItemText, className].filter(Boolean).join(' ')
  const primaryClasses = [
    styles.primaryText,
    size === 'small' ? styles.primarySmall : undefined,
    size === 'tiny' ? styles.primaryTiny : undefined,
  ]
    .filter(Boolean)
    .join(' ')
  const secondaryClasses = [
    styles.secondaryText,
    size === 'small' ? styles.secondarySmall : size === 'tiny' ? styles.secondaryTiny : styles.secondaryNormal,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div {...props} className={rootClasses} style={props.style}>
      <div className={primaryClasses}>{primary}</div>
      {secondary != null && <div className={secondaryClasses}>{secondary}</div>}
    </div>
  )
}
